import { render, staticRenderFns } from "./InvestorReceivablePaymentsDetail.vue?vue&type=template&id=77a5e02f&scoped=true&"
import script from "./InvestorReceivablePaymentsDetail.vue?vue&type=script&lang=js&"
export * from "./InvestorReceivablePaymentsDetail.vue?vue&type=script&lang=js&"
import style0 from "./InvestorReceivablePaymentsDetail.vue?vue&type=style&index=0&id=77a5e02f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a5e02f",
  null
  
)

export default component.exports